import { makeAutoObservable } from "mobx";

export function getDefaultAnalyticsFromDate() {
  const date = new Date();
  date.setMonth(date.getMonth() - 1);
  return date.toISOString().slice(0, 10);
}

export function getDefaultAnalyticsToDate() {
  return new Date().toISOString().slice(0, 10);
}

class StateAnalyticApp {
  constructor() {
    makeAutoObservable(this);
  }

  isLoading = true;

  noRight = false;
  loaded_printed_dates = false;
  loaded_printed_count = false;
  loaded_verify_dates = false;
  loaded_verify_count = false;
  chartPhase = {
    dates: null,
    labelCount: null,
    verifyDates: null,
    verifyCount: null,
  };
  download_printed = false;
  download_verify = false;

  gap_ignore = true;
  from_date = getDefaultAnalyticsFromDate();
  to_date = getDefaultAnalyticsToDate();
  step_period = "d";
  from_date_pr_date = null;
  to_date_pr_date = null;
  from_date_pr_count = null;
  to_date_pr_count = null;
  from_date_verify_date = null;
  to_date_verify_date = null;
  from_date_verify_count = null;
  to_date_verify_count = null;

  mobile = false;

  handlerResize = (size) => {
    this.mobile = size < 1100;
  };

  setParameter = (name, value) => {
    this[`${name}`] = value;
  };

  setChartPhase = (chartId, phase) => {
    this.chartPhase[chartId] = phase;
  };

  clearChartPhase = (chartId) => {
    this.chartPhase[chartId] = null;
  };

  resetChartPhases = () => {
    this.chartPhase = {
      dates: "fetching",
      labelCount: "fetching",
      verifyDates: "fetching",
      verifyCount: "fetching",
    };
  };

  clearAllChartPhases = () => {
    this.chartPhase = {
      dates: null,
      labelCount: null,
      verifyDates: null,
      verifyCount: null,
    };
  };
}

export default new StateAnalyticApp();
